import React, { ChangeEvent, useContext } from 'react'
import LazyImg from 'javascripts/common/LazyImg'
import styles from './ModalFirstView.module.scss'
import ChangeModal from './changeModal'

import Icon from '../../../../../assets/images/identify/icon_first.svg'
import { IdentifyModalValue } from './StartModal'
import ModalButton from 'spa/member/components/ModalButton'

export const ModalFirstView: React.FC<ChangeModal> = (props) => {
  const context = useContext(IdentifyModalValue)
  const options = [
    { value: '運転免許証' },
    { value: 'マイナンバーカード' },
    { value: 'パスポート（住所表示があるもの）' },
    { value: '在留カード' },
    { value: '特別永住者証明書' },
    { value: '住民票' },
  ]

  const changeSelectBox = (e: ChangeEvent<HTMLSelectElement>) => {
    const currentIndex = e.currentTarget.selectedIndex
    context.setOfficialDocument(options[currentIndex].value)
    context.setDocumentPattern(currentIndex + 1)
  }

  const selectOfficialDocument = () => {
    return(
      <>
        <select value={context.officialDocument} onChange={e => changeSelectBox(e)} className={styles.selectBox}>
          {options.map((option, index) => (
            <option key={index} value={option.value}>
              {option.value}
            </option>
          ))}
        </select>
      </>
    )
  }

  return (
    <>
      <div className={styles.overlay}>
        <div className={`${styles.modalContainer} js-modal-container`}>
          <div className={styles.identificationIcon}><LazyImg src={Icon} /></div>
          <div className={styles.sectionTitle}><p><span>公的書類</span>の選択</p></div>
          <div className={styles.sectionText}>
            <p>ご準備が可能な公的書類を選択してください</p>
            <p className={`${styles.sectionAttention} ${styles.small}`}>住所記載がないパスポートでは、本人確認ができないため他書類をご用意ください</p>
          </div>
          <div className={styles.sectionSelect}>{selectOfficialDocument()}</div>
          <div className={styles.sectionBtn}>
            <ModalButton buttonType='BACK' onClick={()=> props.changeModal('startModal')}>1つ前に戻る</ModalButton>
            <ModalButton buttonType='NEXT' onClick={()=> props.changeModal('secondModal')}>次へ</ModalButton>
          </div>
          <div className={styles.sectionBtnClose}><button onClick={() => props.changeModal('')} className={styles.btnItemClose}>キャンセル</button></div>
        </div>
      </div>
    </>
  )
}
